var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecured(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "1 1 26 33",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 35",
    height: 35,
    width: 28,
    "data-type": "ugc",
    "aria-labelledby": "comp-k7suygj62-svgtitle"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Secured_svg__b",
    y2: "76.57%",
    x2: "68.934%",
    y1: "14.864%",
    x1: "28.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F8F8F9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Secured_svg__a",
    d: "M13 33s13-6.6 13-16.5V3.3L13 0 0 3.3v13.2C0 26.4 13 33 13 33z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Secured_svg__a",
    fill: "#60BC57",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Secured_svg__a",
    fill: "url(#Secured_svg__b)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Secured_svg__a",
    strokeWidth: 2,
    stroke: "#60BC57",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "square",
    d: "M13 31.864l.069-.039c.429-.24.909-.527 1.426-.855a33.95 33.95 0 004.34-3.255C22.706 24.277 25 20.49 25 16.5V4.078L13 1.032 1 4.078V16.5c0 3.991 2.294 7.777 6.164 11.215A33.95 33.95 0 0013 31.864z",
    strokeWidth: 2,
    stroke: "#FFF",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 33s13-6.6 13-16.5V3.3L13 0 0 3.3v13.2C0 26.4 13 33 13 33z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    stroke: "#61AD5A",
    fill: "none",
    d: "M18 13l-4.375 7L11 17.429"
  }))));
}
export default "data:image/svg+xml,%3csvg preserveAspectRatio='xMidYMid meet' id='comp-k7suygj62svgcontent' data-bbox='1 1 26 33' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 28 35' height='35' width='28' data-type='ugc' role='img' aria-labelledby='comp-k7suygj62-svgtitle'%3e%3ctitle id='comp-k7suygj62-svgtitle'%3e%3c/title%3e %3cg%3e %3cdefs%3e %3clinearGradient id='0f7b9273-2079-4322-908c-39a65bc68a76' y2='76.57%25' x2='68.934%25' y1='14.864%25' x1='28.072%25'%3e %3cstop offset='0%25' stop-opacity='0' stop-color='%23FFFFFF'%3e%3c/stop%3e %3cstop offset='100%25' stop-color='%23F8F8F9'%3e%3c/stop%3e %3c/linearGradient%3e %3cpath id='96d2f7d7-6f2c-45c9-aa2b-76eeb3e75393' d='M13 33s13-6.6 13-16.5V3.3L13 0 0 3.3v13.2C0 26.4 13 33 13 33z'%3e%3c/path%3e %3c/defs%3e %3cg stroke-linejoin='round' stroke-linecap='round' fill-rule='evenodd'%3e %3cg transform='translate(1 1)'%3e %3cuse xlink:href='%2396d2f7d7-6f2c-45c9-aa2b-76eeb3e75393' fill='%2360BC57' fill-opacity='.34'%3e%3c/use%3e %3cuse xlink:href='%2396d2f7d7-6f2c-45c9-aa2b-76eeb3e75393' fill='url(%230f7b9273-2079-4322-908c-39a65bc68a76)'%3e%3c/use%3e %3cuse xlink:href='%2396d2f7d7-6f2c-45c9-aa2b-76eeb3e75393' stroke-width='2' stroke='%2360BC57' fill='none'%3e%3c/use%3e %3cpath stroke-linejoin='square' d='M13 31.864l.069-.039c.429-.24.909-.527 1.426-.855a33.95 33.95 0 004.34-3.255C22.706 24.277 25 20.49 25 16.5V4.078L13 1.032 1 4.078V16.5c0 3.991 2.294 7.777 6.164 11.215A33.95 33.95 0 0013 31.864z' stroke-width='2' stroke='%23FFFFFF' fill='none'%3e%3c/path%3e %3cpath stroke-linejoin='square' d='M13 33s13-6.6 13-16.5V3.3L13 0 0 3.3v13.2C0 26.4 13 33 13 33z' fill='none'%3e%3c/path%3e %3c/g%3e %3cpath stroke-width='2' stroke='%2361AD5A' fill='none' d='M18 13l-4.375 7L11 17.429'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgSecured as ReactComponent };